import React, { useEffect, useState } from 'react';
import './HomeView.scss';
import HomeLayout from '../../../Layouts/HomeLayout/HomeLayout';
import ModernCard from '../../../Components/HomeCards/ModernCard/ModernCard';
import fan from '../../../Assets/pngIcon/fan.png';
import gas from '../../../Assets/pngIcon/gas.png';
import tree from '../../../Assets/pngIcon/tree.png';
import { useDispatch, useSelector } from 'react-redux';
import { createWallet, getHomeDetails } from './redux/homeSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProfileDetails } from '../MyProfileView/redux/profileSlice';
import { Button } from '../../../Components/Common';
import { Pathname } from '../../../Router/Pathname';
import LeoButton from '../../../Components/Common/LeoButton/LeoButton';
import CustomCard from '../../../Components/HomeCards/ModernCard/Custom';
import { FavouriteStationsCard } from '../FavouriteStationsView';

import PwaAnimation from '../../../Assets/svg/PwaAnimation.svg';
import AddToHomeModal from '../Modal/AddToHomeModal';
const HomeView = () => {
    const { homeInfo, loading } = useSelector((store) => store.home);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [isAppInstalled, setIsAppInstalled] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const transactionId =
        searchParams.get('transactionId') || location?.state?.transactionId;

    const [isModalVisible, setIsModalVisible] = useState(false);

    const currentUser =
        useSelector(
            (store) => store?.profile?.profileInfo?.payload?.customer?.user_name
        ) || 'User';

    useEffect(async () => {
        let data = await dispatch(getHomeDetails());
        dispatch(getProfileDetails());
        //   if (!data?.payload?.payload?.is_onboarded) {
        //         navigate('/userinfo');
        //     }
    }, []);

    // useEffect(() => {
    //     console.log("homeInfo",homeInfo)
    //     if (homeInfo !== null && !homeInfo?.payload?.is_onboarded) {
    //         navigate('/userinfo');
    //     }
    // }, [homeInfo]);


    useEffect(() => {
        if (transactionId) {
            navigate(`${Pathname.WALLET}?transactionId=${transactionId}`, {
                replace: true,
                state: { transactionId: transactionId },
            });
        }
    }, [transactionId, navigate]);

    useEffect(() => {
        const isStandalone =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;
        setIsAppInstalled(isStandalone);
    }, []);

    return (
        <HomeLayout>
            <section className="HomeView responsive--homeView ">
                <div className="HomeView--Header responsive--header">
                    <p className="HomeView--profileName">
                        Hi,{' '}
                        <span
                            style={{
                                color: '#00aa74',
                            }}
                        >
                            {currentUser}
                        </span>
                    </p>
                    <LeoButton
                        onClick={() =>
                            navigate(Pathname.CHAT_BOT, { state: { currentUser } })
                        }
                    />
                    <div className="HomeView--Card">
                        <div style={{ width: '50%' }}>
                            <CustomCard
                                heading="Total Charging Sessions"
                                subheading={
                                    homeInfo?.payload?.session_count
                                        ? homeInfo?.payload?.session_count
                                        : 0
                                }
                                icon={<img src={gas} alt="Charging Sessions Icon" />}
                            />
                        </div>
                        <div style={{ width: '50%' }}>
                            <CustomCard
                                heading="Total Units Consumed"
                                subheading={`${Number(
                                    homeInfo?.payload?.unit_consumed
                                        ? homeInfo?.payload?.unit_consumed
                                        : 0
                                ).toFixed(2)} kwh`}
                                icon={<img src={fan} alt="Energy Consumption Icon" />}
                            />
                        </div>
                    </div>

                    <FavouriteStationsCard />

                    <ModernCard
                        heading="Carbon Emissions Saved"
                        subheading={`${parseFloat(
                            homeInfo?.payload?.carbon_emission
                                ? homeInfo?.payload?.carbon_emission
                                : 0
                        ).toFixed(2)} Kg`}
                        className={'HomeView--treeIcon'}
                        icon={<img src={tree} alt="Carbon Emissions Icon" />}
                    />
                </div>
            </section>
            {!isAppInstalled && !isModalVisible && (
                <div className="app-container">
                    <img
                        src={PwaAnimation}
                        alt="Add to Home Screen Animation"
                        className="floating-card"
                        onClick={() => setIsModalVisible(true)}
                    />
                </div>
            )}

            <div className="HomeView--NavbarSpacer" />

            <AddToHomeModal
                isOpen={isModalVisible}
                onClose={() => setIsModalVisible(false)}
            />

        </HomeLayout>
    );
};

export default HomeView;
